// App Center API Swagger
// https://aks-cluster-prod.westus3.cloudapp.azure.com/swagger/index.html

import { APP_CENTER_API_URL } from './app-center.constants';
import {
  AppliedUserParams,
  ImpersonationParams,
  ImpersonationQueryParams
} from './app-center.types';
import { del, get, patch, put } from 'services/request.service';

const BASE_URL = APP_CENTER_API_URL;

// AppliedUser
export const getAppliedUsers = async (params: AppliedUserParams, page = 1) => {
  const { data } = await get({
    url: `${BASE_URL}/AppliedUser/Search`,
    params: { ...params, page }
  });
  return data.results;
};

// Impersonation
export const impersonateUser = async (data: ImpersonationParams) => {
  return await put({
    url: `${BASE_URL}/Impersonation`,
    data
  });
};

export const patchImpersonation = async (params: ImpersonationParams) => {
  return await patch({
    url: `${BASE_URL}/Impersonation`,
    params: { ...params }
  });
};

export const deleteImpersonation = async (id: string) => {
  return await del({
    url: `${BASE_URL}/Impersonation`,
    params: { id }
  });
};

export const getImpersonationList = async (params: ImpersonationQueryParams, page = 1) => {
  const { applicationCode, environmentCode, ...rest } = params;
  return await get({
    url: `${BASE_URL}/Impersonation/Search/${applicationCode}/${environmentCode}`,
    params: { ...rest, page, pageSize: 100, includeInactive: false }
  });
};
